import React, { useEffect } from 'react';

const GoogleAnalytics = () => {
  useEffect(() => {
    // Google Analytics 4 配置
    const GA_TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID || 'G-CD31NY94JL';
    
    // 如果没有配置GA ID，则不加载
    if (GA_TRACKING_ID === 'G-XXXXXXXXXX') {
      console.log('Google Analytics未配置，请在环境变量中设置REACT_APP_GA_TRACKING_ID');
      return;
    }
    
    // 加载Google Analytics脚本
    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`;
    document.head.appendChild(script1);

    // 初始化Google Analytics
    const script2 = document.createElement('script');
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${GA_TRACKING_ID}', {
        page_title: 'AiQiji课程表制作',
        page_location: window.location.href,
        custom_map: {
          'custom_parameter_1': 'app_name',
          'custom_parameter_2': 'version'
        }
      });
      
      // 设置自定义参数
      gtag('config', '${GA_TRACKING_ID}', {
        app_name: 'AiQiji课程表制作',
        version: '4.0.0'
      });
    `;
    document.head.appendChild(script2);

    // 页面访问事件
    gtag('event', 'page_view', {
      page_title: 'AiQiji课程表制作',
      page_location: window.location.href,
      app_name: 'AiQiji课程表制作',
      version: '4.0.0'
    });

    // 应用启动事件
    gtag('event', 'app_start', {
      event_category: 'engagement',
      event_label: '课程表应用启动',
      app_name: 'AiQiji课程表制作',
      version: '4.0.0'
    });

    // 清理函数
    return () => {
      // 移除脚本（如果需要）
      if (script1.parentNode) {
        script1.parentNode.removeChild(script1);
      }
      if (script2.parentNode) {
        script2.parentNode.removeChild(script2);
      }
    };
  }, []);

  // 自定义事件跟踪函数
  const trackEvent = (eventName, parameters = {}) => {
    if (typeof gtag !== 'undefined') {
      gtag('event', eventName, {
        event_category: 'user_interaction',
        app_name: 'AiQiji课程表制作',
        version: '4.0.0',
        ...parameters
      });
    }
  };

  // 将跟踪函数暴露到全局，供其他组件使用
  useEffect(() => {
    window.trackEvent = trackEvent;
  }, []);

  return null; // 这个组件不渲染任何内容
};

export default GoogleAnalytics;
